import { render, staticRenderFns } from "./GerenciarAtendimentos.vue?vue&type=template&id=64cd05db&scoped=true"
import script from "./GerenciarAtendimentos.vue?vue&type=script&lang=js"
export * from "./GerenciarAtendimentos.vue?vue&type=script&lang=js"
import style0 from "./GerenciarAtendimentos.vue?vue&type=style&index=0&id=64cd05db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cd05db",
  null
  
)

export default component.exports